import { Navigate, RouterProvider, createBrowserRouter } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { StatusMessage } from "./components/StatusMessage";
import { AuthProvider, useAuth } from "./services/auth";
import { LoginPage } from "./LoginPage";
import { AnaliseGraficaPage } from "./modules/engajamento/AnaliseGraficaPage";
import { IndicadoresPage } from "./modules/engajamento/IndicadoresPage";
import { ProvaFacilPage } from "./modules/provaFacil/ProvaFacilPage";
import { EvasaoPage } from "./modules/evasao/EvasaoPage";
import { QuestionariosPage } from "./modules/questionarios/QuestionariosPage";
import { UsersPage } from "./modules/placeholders/UsersPage";

function ProtectedApp() {
  const { profile, loading } = useAuth();

  if (loading) {
    return (
      <main className="loading-page">
        <StatusMessage>Carregando sessao...</StatusMessage>
      </main>
    );
  }

  if (!profile) return <LoginPage />;

  const router = createBrowserRouter([
    {
      path: "/",
      element: <AppShell />,
      children: [
        { index: true, element: <Navigate to="/indicadores" replace /> },
        {
          path: "indicadores",
          element: <IndicadoresPage />
        },
        {
          path: "analise-grafica",
          element: <AnaliseGraficaPage />
        },
        {
          path: "evasao",
          element: <EvasaoPage />
        },
        {
          path: "questionarios",
          element: <QuestionariosPage />
        },
        { path: "prova-facil", element: <ProvaFacilPage /> },
        { path: "usuarios", element: <UsersPage /> },
        { path: "*", element: <Navigate to="/indicadores" replace /> }
      ]
    }
  ]);

  return <RouterProvider router={router} />;
}

export function App() {
  return (
    <AuthProvider>
      <ProtectedApp />
    </AuthProvider>
  );
}
